import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import querystring from "query-string";
import { Redirect, Route, useHistory } from "react-router-dom";
import { Box } from "@material-ui/core";

// Local
import PanelContainer from "../../components/Panels/PanelContainer";
import Panel from "../../components/Panels/Panel";
import ExercisesScreen from "../../components/Exercises/ExercisesScreen";
import ExerciseDetailsPanel from "../../components/Panels/ExerciseDetailsPanel";
import CustomExercisePanel from "../../components/Panels/CustomExercisePanel";
import { updateQuery } from "../../util/utilFunctions";
import { PageHeader, PageToolBar } from "../../components";
import { FloatingCircleButton } from "../../components/Buttons";
import { colors } from "../../styles";
import SlidingFlexTransition from "../../components/Transitions/SlidingFlexTransition";
import NoticeBar from "../../components/Notice/NoticeBar";
import { textStrings } from "../../textStrings";
import CustomBreadcrumb from "../../components/BreadCrumbs/BreadCrumbs";

const views = {
  exerciseList: {
    key: "exerciseList",
    exerciseList: true,
  },
  exerciseDetails: {
    key: "exerciseDetails",
    exerciseList: true,
    exerciseDetails: true,
  },
  customExerciseDetails: {
    key: "customExerciseDetails",
    exerciseList: true,
    customExerciseDetails: true,
  },
};

const breadcrumbItems = [
  { label: textStrings.libraries, path: "/libraries" },
  { label: textStrings.exercises },
];

const MY_EXERCISES_LINK_TO = {
  pathname: "/libraries/exercises/my-exercises",
  state: {
    myExercises: true,
  },
};

const NASM_EXERCISES_LINK_TO = {
  pathname: "/libraries/exercises/nasm-exercises",
  state: {
    myExercises: false,
  },
};

// Component
export default function Exercises() {
  const userType = JSON.parse(localStorage.getItem("AUTH_TOKEN"));
  const history = useHistory();
  const location = history.location;
  const query = querystring.parse(location.search);
  const view = query.view || views.exerciseList.key;
  const currentTab = location.pathname.split("/").pop();
  const queryParams = querystring.parse(location.search);
  const selectedProfile = useSelector(
    (state) => state?.clubConnect?.selectedProfile,
  );

  const [selectedExerciseId, setSelectedExerciseId] = useState(
    queryParams?.exerciseId || null,
  );
  const resetSelection = () => setSelectedExerciseId(!selectedExerciseId);

  useEffect(() => {
    // Reset the selected exercise when changing My/Nasm Exercise tabs
    resetSelection();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTab]);

  const viewExercisesList = () => {
    return updateQuery(location.search, {
      exerciseId: undefined,
      view: views.exerciseList.key,
    });
  };

  const createExerciseDetailsLink = () => {
    return updateQuery(location.search, {
      view: views.customExerciseDetails.key,
      exerciseId: "new",
    });
  };

  const viewExerciseDetailsLink = (
    exerciseId,
    showProgressionsRegressions = true,
  ) => {
    if (currentTab === "my-exercises") {
      return updateQuery(location.search, {
        view: views.customExerciseDetails.key,
        exerciseId: exerciseId,
      });
    }

    // default to nasm-exercises view
    return updateQuery(location.search, {
      view: views.exerciseDetails.key,
      exerciseId: exerciseId,
      showProgressionsRegressions: showProgressionsRegressions,
    });
  };

  const ExercisesTab = () => {
    return (
      <PageToolBar
        linkOptions={[
          {
            label: textStrings.edgeExercises,
            to: NASM_EXERCISES_LINK_TO,
          },
          {
            label: textStrings.myExercises,
            to: MY_EXERCISES_LINK_TO,
          },
        ]}
        color={selectedProfile?.ClubId ? colors.graphite : colors.lightBlue}
      />
    );
  };

  const handleExerciseMenu = () => {
    // handleDropdownClose();
    history.push({
      pathname: "/libraries/exercises/my-exercises",
      search: createExerciseDetailsLink(),
    });
  };

  return (
    <>
      <Route exact path="/libraries/exercises">
        <Redirect to={NASM_EXERCISES_LINK_TO} />
      </Route>
      <PageHeader title={textStrings.exercises} />
      <FloatingCircleButton
        disabled={view === views.customExerciseDetails.key}
        onClick={handleExerciseMenu}
      />
      <ExercisesTab />
      <Box>
        {userType?.cc_manager && (
          <Box style={{ padding: "20px 90px 0px 90px" }}>
            <NoticeBar />
          </Box>
        )}
        <CustomBreadcrumb items={breadcrumbItems} />
        <PanelContainer padding={"2px 90px 30px 125px"}>
          <SlidingFlexTransition visible={!!views[view]?.exerciseList}>
            <Panel height={800}>
              <ExercisesScreen
                selectedExerciseId={selectedExerciseId}
                setSelectedExerciseId={setSelectedExerciseId}
                resetSelection={resetSelection}
                viewExerciseDetailsLink={viewExerciseDetailsLink}
              />
            </Panel>
          </SlidingFlexTransition>

          <ExerciseDetailsPanel
            visible={!!views[view]?.exerciseDetails}
            resetSelection={resetSelection}
            backLink={viewExercisesList}
            viewExerciseDetailsLink={viewExerciseDetailsLink}
          />
          <CustomExercisePanel
            visible={!!views[view]?.customExerciseDetails}
            backLink={viewExercisesList}
            exerciseId={selectedExerciseId}
            resetSelection={resetSelection}
          />
        </PanelContainer>
      </Box>
    </>
  );
}
